import { createSlice } from '@reduxjs/toolkit'

export const productTileSlice = createSlice({
  name: 'product-tile',
  initialState: {
    colorMode: null,
  },
  reducers: {
    setColorMode: (state, action) => {
      state.colorMode = action.payload
    },
  },
})

export const { setColorMode } = productTileSlice.actions

export default productTileSlice.reducer
